<template>
    <div>
        <svg ref="gantt" />
    </div>
</template>


<script>
import Gantt from 'frappe-gantt'

export default {
    props: {
        tasks: {
            type: Array,
            required: true,
            default: []
        }
    },
    data () {
        return {
            gantt: {}
        };
    },
    watch: {
        tasks () {
            this.setGantt()
        }
    },
    mounted() {
        this.setGantt()
    },
    methods: {
        setGantt() {
            this.gantt = new Gantt(this.$refs.gantt, this.tasks, {
                on_click: task => {
                    this.$emit('task-updated', task);
                },
                on_date_change: (task, start, end) => {
                    this.$emit('task-date-updated', { task, start, end });
                },
                on_progress_change: (task, progress) => {
                    this.$emit('task-progress-updated', { task, progress });
                },
                on_view_change: function() {
                    var bars = document.querySelectorAll(id + " .bar-group");
                    for (var i = 0; i < bars.length; i++) {
                        bars[i].addEventListener("mousedown", stopEvent, true);
                    }
                    var handles = document.querySelectorAll(id + " .handle-group");
                    for (var i = 0; i < handles.length; i++) {
                        handles[i].remove();
                    }
                }
            })
        },
        stopEvent(event) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
}
</script>

<style lang="scss">
@import "~frappe-gantt/dist/frappe-gantt.css";

.cc-green g rect { fill: darkgreen !important; }
.cc-light-green g rect { fill: lightgreen !important; }

#gantt
  {pointer-events: none}
</style>